import { create } from 'zustand';
import type { PlayerView, GameSummary } from '@durak/shared';
import { getSocket } from '../lib/socket';

interface ChatMsg { from: string; name: string; text: string; ts: number }

interface GameState {
  view: PlayerView | null;
  lobby: GameSummary[];
  chat: ChatMsg[];
  error: string | null;
  attach: () => () => void;
  setView: (v: PlayerView | null) => void;
  setError: (e: string | null) => void;
  clearChat: () => void;
}

export const useGame = create<GameState>((set, get) => ({
  view: null,
  lobby: [],
  chat: [],
  error: null,
  setView: (v) => set({ view: v }),
  setError: (e) => set({ error: e }),
  clearChat: () => set({ chat: [] }),
  attach: () => {
    const s = getSocket();
    const onState = (v: PlayerView) => set({ view: v });
    const onLobby = (list: GameSummary[]) => set({ lobby: list });
    const onChat = (m: ChatMsg) => set({ chat: [...get().chat, m].slice(-100) });
    const onErr = (msg: string) => set({ error: msg });
    const onReconnect = () => {
      const v = get().view;
      if (v?.gameId) s.emit('game:sync', { gameId: v.gameId });
    };
    s.on('game:state', onState);
    s.on('lobby:list', onLobby);
    s.on('game:chat', onChat);
    s.on('error:msg', onErr);
    s.on('connect', onReconnect);
    return () => {
      s.off('game:state', onState);
      s.off('lobby:list', onLobby);
      s.off('game:chat', onChat);
      s.off('error:msg', onErr);
      s.off('connect', onReconnect);
    };
  },
}));
